import { useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Box, Container, Typography, Paper } from "@mui/material";
import { ResetPasswordForm } from "../../components/auth";
import { useAuth } from "../../hooks";
import config from "../../config/environment";
import heightenLogo from "../../assets/images/heighten-logo.png";

const ResetPasswordPage = () => {
  const { token } = useParams<{ token: string }>();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already authenticated, redirect to home page
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }

    // Validate token exists
    if (!token) {
      navigate("/auth/login", { replace: true });
    }
  }, [isAuthenticated, navigate, token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#1e293b", // slate-800 to match sidebar
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 3 }}>
            <Box
              component={Link}
              to="/"
              sx={{ display: "inline-block", textDecoration: "none" }}
            >
              <Box
                component="img"
                src={heightenLogo}
                alt="Heighten Management"
                sx={{ cursor: "pointer" }}
              />
            </Box>
          </Box>

          <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
            <Typography component="h1" variant="h5" align="center" gutterBottom>
              Reset Your Password
            </Typography>

            <ResetPasswordForm />
          </Paper>

          {/* Footer */}
          <Typography
            variant="caption"
            align="center"
            sx={{ mt: 4, color: "white" }}
          >
            © 2025 {config.app.tagline}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ResetPasswordPage;
